export default __webpack_public_path__ + "static/media/bresil.7fff150d.png";